import CrossIcon from '@components/icons/cross-icon';
import TouchPhoneIcon from '@components/icons/touch-phone-icon';
import { isSome, v2_useCmsBlock } from '@crocodille/common';
import cn from 'classnames';
import { parseCookies, setCookie } from 'nookies';
import { useEffect, useState } from 'react';

import styles from './app-header-banner.module.scss';

const APP_PROMO_DISMISSED_COOKIE = 'app_promo_dismissed';

const AppHeaderBanner: React.FC = () => {
  const [open, setOpen] = useState(() => {
    return parseCookies()[APP_PROMO_DISMISSED_COOKIE] !== 'true';
  });

  const onClose = () => {
    setCookie(null, APP_PROMO_DISMISSED_COOKIE, 'true', {
      maxAge: 60 * 60 * 14, // 14 days
      path: '/',
    });

    setOpen(false);
  };

  const { data: block } = v2_useCmsBlock('app_promo_banner');

  const shown = open && isSome(block);

  useEffect(() => {
    document.documentElement.classList.toggle('app-header-banner-open', shown);
  }, [shown]);

  if (!shown) {
    return null;
  }

  return (
    <aside className={cn(styles.container)}>
      <a className={styles.inner} href={block.link ?? undefined}>
        <TouchPhoneIcon className={styles.icon} />
        <span className={styles.text}>{block.name}</span>
      </a>
      <button className={styles.closeButton} onClick={() => onClose?.()}>
        <CrossIcon />
      </button>
    </aside>
  );
};

export default AppHeaderBanner;
